var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    _vm._l(_vm.stats, function(stat, index) {
      return _c("li", { key: index, staticClass: "stats-block" }, [
        _c("a", { attrs: { href: stat.listingUrl } }, [
          _c("h3", { staticClass: "stats-title" }, [
            _vm._v(_vm._s(stat.label))
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", { staticClass: "data-block-number inline-block" }, [
              _c("h3", { staticClass: "data-value" }, [
                _vm._v(_vm._s(stat.count))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "data-label" }, [
                _vm._v(_vm._s(stat.labelCount))
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "data-block-number inline-block" }, [
              _c("h3", { staticClass: "data-value" }, [
                _vm._v(_vm._s(_vm.$filters.numberFormat(stat.amount, true)))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "data-label" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      stat.labelAmount
                        ? stat.labelAmount
                        : _vm.$l10n.__("Montant")
                    ) +
                    "\n                    "
                )
              ])
            ])
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }